// <fiee-dialog> is the island behind the kiosk's single dialog (view/panel_modal.templ).
//
// The content is not built here: any element with
// hx-target="#panel-dialog-body" fetches a server-rendered fragment and HTMX
// swaps it in. This island only owns the open/close behaviour around that:
//
//   - opens the <dialog> modally once a swap lands inside it (htmx 4 dispatches
//     htmx:after:swap on the element that issued the request, so it is caught
//     on the document and filtered by target);
//   - closes on the close button, on a tap outside the sheet and on Escape
//     (native to a modal <dialog>);
//   - empties the body on close, so an embedded PDF stops loading and the next
//     visitor does not reopen the previous one's content.
export class FieeDialog extends HTMLElement {
  #dialog: HTMLDialogElement | null = null;
  #body: HTMLElement | null = null;
  #onSwap = (e: Event) => this.#afterSwap(e);

  connectedCallback() {
    this.#dialog = this.querySelector("dialog");
    this.#body = this.querySelector("#panel-dialog-body");
    if (!this.#dialog || !this.#body) return;

    document.addEventListener("htmx:after:swap", this.#onSwap);

    this.#dialog.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      // A click on the <dialog> itself is a click on the backdrop: the sheet
      // fills the dialog box, so anything inside it has another target.
      if (target === this.#dialog || target.closest("[data-dialog-close]")) {
        this.close();
      }
    });
    this.#dialog.addEventListener("close", () => this.#body?.replaceChildren());
  }

  disconnectedCallback() {
    document.removeEventListener("htmx:after:swap", this.#onSwap);
  }

  close() {
    if (this.#dialog?.open) this.#dialog.close();
  }

  #afterSwap(e: Event) {
    const target = (e as CustomEvent).detail?.ctx?.target as Element | undefined;
    if (!this.#dialog || !target || !this.#dialog.contains(target)) return;
    if (!this.#dialog.open) this.#dialog.showModal();
    // A new fragment (e.g. from "Volver al día") starts at the top.
    this.#body?.scrollTo({ top: 0 });
  }
}
